<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal modal-account-verification" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content" style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal">
                <span>
                  Change Email Address
                </span>
                            </p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg" alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content" style="overflow: hidden">
                                <TextField
                                    v-model="password"
                                    name="password"
                                    label="Current Password"
                                    :type="isShowPassword ? 'text' : 'password'"
                                >
                                    <template #append-icon>
                                        <a @click.prevent="toggleShowPassword">
                                            <img v-if="!isShowPassword" src="~@/assets/images/Eye_Icon_lighter.svg"
                                                 alt="">
                                            <img v-else src="~@/assets/images/Eye_Icon_Splash.svg" alt="">
                                        </a>
                                    </template>
                                </TextField>
                                <TextField
                                    v-model="new_email"
                                    name="new_email"
                                    label="New Email Address"
                                    type="email"
                                />
                            </div>
                            <div>
                                <div class="d-flex justify-content-center mt-2">
                                    <button v-text="'Next'"
                                            :disabled="!password || !new_email"
                                            class="btn-dialog btn-sm ok-btn mr-2" @click="performChangeEmail">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import TextField from "@/commons/FormElements/TextField.vue";
import DibbleApi from "@/api";
import DibbleJs from "@/dibble";

export default {
    name: "ModalAccountChangeEmail",
    components: {TextField},
    data() {
        return {
            password: '',
            new_email: '',
            isShowPassword: false,
        };
    },
    computed:{
        isOwner() {
            return this.$cookies.get("_user").is_owner;
        }
    },
    methods: {
        toggleShowPassword() {
            this.isShowPassword = !this.isShowPassword;
        },
        performChangeEmail() {
            DibbleJs.showLoader();
            const data = {
                '#request': this.isOwner
                    ? DibbleApi.api.accountChangeFactor
                    : DibbleApi.api.managedUserChangeFactor,
                factor_type: 'EMAIL',
                curr_password: this.password,
                new_email: this.new_email,
            };
            DibbleJs.callApiRequest(data, (responseData) => {
                if (DibbleApi.isResponseSuccess(responseData)) {
                    const {is_verified} = responseData;
                    if (!is_verified) {
                        DibbleJs.toastSuccessMessage('Email changed successfully');
                    } else {
                        this.$emit('emit-verification', responseData)
                    }
                } else {
                    DibbleJs.toastErrorMessage(responseData.message);
                }
                DibbleJs.hideLoader();
            });
        },
        closeModal() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.form-box.otp-input-wrap {
    box-shadow: 0px 12px 20px -16px #767676;
    /* -webkit-box-shadow: 0px 12px 20px -12px #767676; */
    -moz-box-shadow: -1px 7px 5px -2px rgba(191, 191, 191, 0.75);
    background: #e8eff1;
    padding-top: 14px;
}

.otp-input {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    text-align: center;
    font-size: 25px;
    font-weight: 600;
}
</style>
